module.exports = __webpack_public_path__ + "img/earthStarCommentator.a63b4b41.png";